import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import usePathname from '@openclassrooms/routing/hooks/usePathname';
import { featureDecisions } from '@openclassrooms/utils/feature-flags';
export type HelpType = 'student' | 'employer' | 'none';
const routeConfig: Partial<Record<HelpType, RegExp[]>> = {
  // 'none' has the highest priority. Use this for pages that should have no help
  none: [/^\/[^/]+\/search/, /^\/[^/]+\/welcome\/recruiter\/funnel\/requirements/],
  employer: [/^\/[^/]+\/business(\/.*)?$/, /^\/[^/]+\/welcome(\/.*)?$/, /^\/[^/]+\/organizations(\/.*)?$/, /^\/[^/]+\/match-declarations\/candidate(\/.*)?$/, /^\/[^/]+\/claim-job(\/.*)?$/, /^\/[^/]+\/job-applications(\/.*)?$/, /^\/[^/]+\/talent-suggestions(\/.*)?$/]
};
function getHelpTypeFromPathname(pathname: string): HelpType {
  const defaultHelpType: HelpType = 'student';
  if (typeof pathname !== 'string') {
    return defaultHelpType;
  }
  if (routeConfig.none?.some(pattern => pattern.test(pathname)) || !featureDecisions.isHeaderContactPanelEnabled()) {
    return 'none';
  }
  const otherConfiguredTypes = (Object.keys(routeConfig) as Array<HelpType>).filter(type => type !== 'none');
  const matchedType = otherConfiguredTypes.find(type => routeConfig[type]?.some(pattern => pattern.test(pathname)));
  return matchedType ?? defaultHelpType;
}
export default function useHelpTypeFromPathname() {
  const $ = _c(10);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = getHelpTypeFromPathname(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const defaultHelpType = t0;
  const [helpType, setHelpType] = useState(defaultHelpType);
  let t1;
  let t2;
  if ($[2] !== pathname) {
    t1 = () => {
      setHelpType(getHelpTypeFromPathname(pathname));
    };
    t2 = [pathname];
    $[2] = pathname;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== helpType) {
    t3 = () => {
      setHelpType(helpType === "student" ? "employer" : "student");
    };
    $[5] = helpType;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== helpType || $[8] !== t3) {
    t4 = {
      helpType,
      switchHelp: t3
    };
    $[7] = helpType;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}